var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trial__timer"},[_c('svg-icon',{attrs:{"name":"timer"}}),_c('span',[_vm._v("22 часа 43 минуты")]),_c('Tooltip',[_vm._v(" Таймер показывает остаток времени для прохождения заданий образоватльного дня ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }